const LABELS = {
  active: "Weather watch active",
  inactive: "Watch paused",
};

export default function WeatherWatchStatusBadge({ active = false, className = "" }) {
  return (
    <span
      className={`weather-watch-status-badge weather-watch-status-badge--${
        active ? "active" : "inactive"
      } ${className}`.trim()}
      role="status"
    >
      {active ? LABELS.active : LABELS.inactive}
    </span>
  );
}
